<template>
    <div class="confirm-email">
        <div class="container-btn">
            <button class="btn-back" @click="backToLogin">
                <b-icon icon="arrow-left"></b-icon> Voltar
            </button>
        </div>
        <div class="container-form">
            <div class="forms">
                <b-row>
                    <b-col>
                        <b-col lg="12" class="pb-3 mb-3 d-flex justify-content-center">
                            <div>
                                <img src="../assets/logomarca-white.svg" alt="Logomarca cogumelos umami">
                            </div>
                        </b-col>
                        <b-alert v-model="showAlert" show :variant="alertType" dismissible>
                            <b-icon-exclamation-triangle-fill variant="danger" v-if="alertType == 'danger'" />
                            <b-icon v-else icon="check" variant="success" />
                            {{ textAlert }}
                        </b-alert>
                        <div>
                            <b-form @submit="submit">
                                <b-form-group class="pb-3">
                                    <label class="label">Informe o email cadastrado para recuperar a sua senha:</label>
                                    <b-form-input type="email" required v-model="$v.form.email.$model" class="form-control"
                                        placeholder :state="validateState('email')"></b-form-input>
                                </b-form-group>
                                <b-col class="d-flex justify-content-center pb-3">
                                    <b-button class="btn-submit login" type="submit">
                                        ENVIAR
                                        <b-spinner v-show="showSpinner" small></b-spinner>
                                    </b-button>
                                </b-col>
                            </b-form>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { ConfirmEmail } from "../services/Auth"

export default {
    data() {
        return {
            showAlert: false,
            textAlert: "",
            alertType: "",
            showSpinner: false,
            form: {
                email: "",
            },
        };
    },
    validations: {
        form: {
            email: {
                required,
                email,
            },
        },
    },
    mixins: [validationMixin],
    methods: {
        backToLogin() {
            this.$router.push("/")
        },
        validateState(field) {
            const { $dirty, $error } = this.$v.form[field];
            return $dirty ? !$error : null;
        },
        submit(evt) {
            evt.preventDefault();
            this.showSpinner = true;
            ConfirmEmail(this.form)
                .then(() => {
                    this.showAlert = true;
                    this.alertType = "success";
                    this.textAlert = "Verifique sua caixa de entrada";
                    this.showSpinner = false;
                })
                .catch(() => {
                    this.showAlert = true;
                    this.alertType = "danger";
                    this.textAlert = "Verifique seus dados e tente novamente!";
                    this.showSpinner = false;
                });
        }
    }
}
</script>

<style scoped>
.confirm-email {
    background-color: #E5E5E5;
    height: 100vh;
    width: 100vw;
    overflow: auto;
}

.container-btn {
    display: flex;
    align-items: center;
    padding-left: 20px;
    width: 100%;
    height: 10%;
}

.btn-back {
    background-color: transparent;
    border: none;
    color: #5e5a5a;
    font-size: 20px;
    padding: 12px;
}

.btn-back:focus {
    outline: none;
    border: none;
}

.container-form {
    width: 100%;
    height: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.forms {
    background-color: #BE8250;
    box-shadow: 0px 0px 10px #333333;
    border-radius: 4px;
    padding: 40px 40px;
    width: fit-content;
    max-height: fit-content;
}

input {
  border-radius: 12px;
  border: none;
  background-color: #EEEEEE;
  margin-bottom: 15px;
}

input:focus {
  box-shadow: 0 0 8px 2px #666666;
}

label {
    color: white;
}

.btn-submit {
    color: #D0723E;
    font-size: 15px;
    background-color: #EEEEEE;
    border: 1px solid #D65600;
    border-radius: 12px;
    width: 230px;
    padding: 2px 0;
}

.btn-submit:hover {
    background: #d6d5d5;
    cursor: pointer;
}

.btn-submit:focus {
    outline: none;
    border: none;
}

img {
    width: 100px;
    height: 100px;
}

</style>